


























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class MultiselectList extends Vue {
  
  @Prop({ default: () => [] }) items!: any[]
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: true }) showCheckboxes!: boolean
  @Prop({ default: 'item' }) itemName!: string
  @Prop({ default: [] }) value!: number[]
  @Prop({ default: false }) twoLine!: boolean

  selectedItems: number[] = []

  @Watch('value')
  onValueChange(val: number[]) {
    this.selectedItems = val
  }

  @Watch('selectedItems')
  onselectedItemsChange(val: number[]) {
    this.$emit('input', val)
  }
  
  get oneSelected() {
    return this.selectedItems.length === 1
  }

  get anySelected() {
    return this.selectedItems.length > 0
  }

  get allSelected() {
    return this.selectedItems.length === this.items.length
  }

  get partiallySelected() {
    return this.anySelected && !this.allSelected
  }

  selectAll() {
    this.selectedItems = this.allSelected ? [] : this.items.map(shift => shift.id)
  }

}
